import { createApiCall } from 'lib/base';

const DELETE_IAP_NOTIFICATION = 'DELETE_IAP_NOTIFICATION';

// Backend blocks this for rows confirmed Production - see
// IapNotificationService.Delete. Sandbox and any row the server can't
// positively identify as Production are deletable; admincp's own
// confirmation dialog (see detail.tsx) is the safeguard for the latter.
const deleteIapNotificationApi = createApiCall<{ id: string }>(
  DELETE_IAP_NOTIFICATION,
  ({ id }) => ({
    endpoint: `/api/admin/iap-notifications/${id}`,
    method: 'DELETE',
  })
);

export default deleteIapNotificationApi;
